// Platform active-session listing + revoke (auth-service /platform/sessions via the
// gateway). Cross-tenant, platform-scoped. Revoke is audit-first (server-side).
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);
const BASE = `${API_V1}/platform/sessions`;

export interface PlatformSession {
  id: string;
  userId: string;
  userEmail?: string | null;
  userName?: string | null;
  tenant?: string | null;
  device?: string | null;
  browser?: string | null;
  os?: string | null;
  ip?: string | null;
  location?: string | null;
  mfaVerified: boolean;
  riskScore: number;
  createdAt?: string | null;
  lastActivityAt?: string | null;
  expiresAt?: string | null;
}

export interface SessionPage {
  sessions: PlatformSession[];
  pagination: { page: number; limit: number; total: number; totalPages: number };
}

export const listSessions = (params?: {
  page?: number;
  limit?: number;
  userId?: string;
  tenantId?: string;
}) => axios.get<SessionPage>(BASE, { params }).then((r) => r.data);

export const revokeSession = (id: string, reason?: string) =>
  axios.post<{ message: string }>(`${BASE}/${id}/revoke`, { reason }).then((r) => r.data);
